<template>
  <div>
    <notifications group="notify" position="top center" width="100%"/>
    <router-view>
    </router-view>
  </div>
</template>

<script>
import Utils from './utils.js'
import AuthService from './authservice.js'
import { mapGetters } from 'vuex'

export default {
  name: 'App',
  data() {
    return { }
  },

  computed: {
    ...mapGetters([ 'getErrors' ]),
  },

  mounted() {
    // clean up old vuex state data from localStorage and sessionStorage
    localStorage.removeItem('vuex');
    sessionStorage.removeItem('vuex');
    this.$store.commit("setSearchTerm", '');
  }
}
</script>

<style lang="scss">
@use 'assets/reset';
@use 'assets/variables-mixins' as *;

*, *:before, *:after {
  box-sizing: inherit;
}

html {
  height: 100%;
  width: 100%;
  background: $white;
  color: $main-color;
  font-family: $font;
  box-sizing: border-box;
  overflow-x: hidden;
  .vue-notification {
    margin-top: .5rem;
    font-size: 1.2rem;
  }
  body {
    min-height: 100%;
    .main-super-wrapper {
      margin: 0 auto;
      .text-fix {
        font-size: 0;
        .menu-list-item {
          width: 30%;
          display: inline-block;
          text-align: center;
          text-decoration: none;
          background: $white;
          color: $main-color;
          font-size: 1rem;
          padding: 5px;
          &:hover, .v-link-active {
            background: $main-color;
            color: $white;
          }
        }
      }
    }
  }
}
</style>
